export enum ServiceWorkerServiceTypeNames {
  appLaunching = 'APP-LAUNCHING',
  clearCache = 'CLEAR-CACHE',
  routeChanged = 'ROUTE-CHANGED'
}
